import { StockItemAlreadyReceived } from '../stock';

export interface PurchaseOrderLineReceipt {
  id: string;
  purchaseOrderHeaderId: string;
  purchaseOrderAndLineNo: string;
  supplierKey: string;
  supplierName: string;
  sequence: number;
  productId: string;
  productKey: string;
  productDescription: string;
  currencySymbol: string;
  productTypeId: string;
  productTypeDescription: string;
  unitOfMeasureId: string;
  quantity: number;
  quantityReceived: number;
  balance: number;
  price: number;

  stockItemHeaders: StockItemAlreadyReceived[];
}
